import { Dictionary } from 'lodash';
import { PickRequired, StringTMap } from 'src/app/core/models/common.models';
import { IdeaCustomValueType } from 'src/app/core/models/idea.models';
import { CompanyUser } from 'src/app/core/models/users-models';

export enum CompanyUserStatus {
  undefined = 0,
  invited = 1,
  signed = 2,
  selfSigned = 3,
  invitedMultiLink = 4,
}

export enum CompanyCreationSource {
  manual = 0,
  salesforce = 1,
  hostApp = 2,
  system = 3,
}

export type Company = {
  readonly id?: string;
  readonly name: string;
  readonly createdDt: Date;
  readonly creationSource?: CompanyCreationSource;
  readonly isActive: boolean;
  readonly isDefault: boolean;
  readonly isIndividual?: boolean;
  readonly ownerId?: string;
  readonly portalId: string;
  readonly usersCount: number;
  readonly importance?: number;
  readonly size?: string;
  readonly inviteSid?: string;
  readonly invitationLinksCount: number;
  readonly invitationLinks: StringTMap<CompanyInviteLink>;
  readonly productsCount: number;
  readonly products: StringTMap<CompanyProduct>;
  readonly custom?: Dictionary<IdeaCustomValueType>;
};

export type DBCompany = Company & { readonly id: string };

export type UpdateCompanyUser = PickRequired<CompanyUser, 'id'> | PickRequired<CompanyUser, 'email'>;

export type CompanyAdmin = {
  readonly id?: string;
  readonly portalId: string;
  readonly personId?: string;
  readonly companyId?: string;
  readonly canManage?: boolean;
  readonly isAccessAllowed?: boolean;
};

export type CompanyProduct = {
  readonly name: string;
  readonly isActive: boolean;
  readonly portalId: string;
  readonly productId: string;
  readonly productFile?: string;
  readonly portalFileId?: string;
};

export type CompanyInviteLink = {
  readonly id?: string;
  readonly sid: string;
  readonly companyId: string;
  readonly createdBy: string;
  readonly createdDt: string | Date;
  readonly domain: string;
  readonly portalId: string;
  readonly count: number;
};

export type CompaniesListRequest = {
  readonly withArchival?: boolean;
  readonly withManagementFilter?: boolean;
};

export type CompaniesListResponse = {
  readonly ids: string[];
  readonly companies: StringTMap<DBCompany>;
};

export type CompanyDelRequest = {
  readonly companyIds: string[];
  readonly moveToCompanyId?: string | null;
};

export type CompaniesUsersListRequest = {
  readonly companyId: string;
  readonly total: number;
  readonly skip: number;
  readonly limit: number;
};

export type MoveToCompanyRequest = { fromCompanyId: string; toCompanyId: string; email: string };

export type CompaniesUsersListResponse = CompaniesUsersListRequest & {
  readonly users: readonly CompanyUser[];
};

export type CompanyAddInviteLinkRequest = {
  readonly companyId: string;
  readonly domain: string;
};

export type CompanyDelInviteLinkRequest = {
  readonly linkId: string;
  readonly companyId: string;
  readonly deleteUsers: boolean;
};
